import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ptbr from './languages/pt-br.json'
import en from './languages/en.json'
import es from './languages/es.json'
import config from '@/config/config.js';
import * as Cookies from 'js-cookie'

Vue.use(VueI18n)

var idiomaAtual = 'pt-br'
if(Cookies.get(config.cookieIdioma.cookieName) && Cookies.get(config.cookieIdioma.cookieName) != 'undefined') {
  idiomaAtual = Cookies.get(config.cookieIdioma.cookieName);
}

const i18n = new VueI18n({
  locale: idiomaAtual,
  messages: {
    'pt-br': ptbr,
    'en': en,
    'es': es
  }
})

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js